export const NewMessageModalDetails = [
    {
        description: 'Select the message type you would like to send',
        styleAs: 'list',
    },
    {
        description: 'If you have multiple accounts for the message type, select the service provider you would like to use',
        styleAs: 'list',
    },
    {
        description: 'Select the recipient you would like to send the message to',
        styleAs: 'list',
    },
    {
        description: 'Enter in a subject for the message',
        styleAs: 'list',
    },
    {
        description: 'Type your message in the message editor',
        styleAs: 'list',
    },
    {
        description: 'When you ready to send, click the send button on the bottom right of the modal',
        styleAs: 'list',
    },
    {
        description: 'The system will send your message',
        styleAs: 'list',
    },
    {
        description: 'If your message has been sent, a toast message will appear on the top right of your screen, otherwise if there was an error, an error message will show on the top of the message sending modal',
        styleAs: 'note',
    }
]

export const MessageAssistant = {
    "Messages": {
        items: [
            //Viewing your messages on your dashboard
            {
                heading: 'Viewing your messages',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'message', 'messages', 'check my', 'email', 'sms', 'whatsapp'],
                sections: [
                    {
                        description: 'Go to your messages screen by selecting <b>View All Messages</b> on the dashboard or selecting <b>Messages</b> from the main menu',
                        styleAs: 'list',
                    },
                    {
                        description: 'This will show all your messages from the latest message to the oldest',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Searching for a message
            {
                heading: 'Showing all details for a message',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'search', 'message', 'dashboard', 'messages', 'view', 'platform', 'email', 'sms', 'whatsapp', 'full'],
                sections: [
                    {
                        description: 'To show all message details, navigate to your messages section',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Viewing your messages'
                            }
                        }
                    },
                    {
                        description: 'On the appropriate message bubble on your messages panel, select the <b>read</b> button on the bottom of the bubble',
                        styleAs: 'list',
                    },
                    {
                        description: 'This will receive and show your full message',
                        styleAs: 'list',
                    },
                    {
                        description: 'Once you are done reading your message you can click the hide button to collapse the message or to reply to a message you can click the reply button',
                        styleAs: 'note',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Replying to a message'
                            }
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Replying to a message
            {
                heading: 'Replying to a message',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'reply', 'message', 'dashboard', 'messages', 'view', 'platform', 'email', 'sms', 'whatsapp'],
                sections: [
                    {
                        description: 'To reply to a message, view the full details of the message you would like to reply to',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Showing all details for a message'
                            }
                        }
                    },
                    {
                        description: 'Select the <b>Reply</b> button on the left message bubble options',
                        styleAs: 'list',
                    },
                    {
                        description: 'Type the reply message you would to send',
                        styleAs: 'list',
                    },
                    {
                        description: 'Then select the send button on the bottom right',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Sending a new message
            {
                heading: 'Sending a new message',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'send', 'message', 'dashboard', 'messages', 'view', 'platform', 'email', 'sms', 'whatsapp', 'full'],
                sections: [
                    {
                        description: 'To send a message, navigate to your messages section',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Viewing your messages'
                            }
                        }
                    },
                    {
                        description: 'On the messages search panel on the top of the screen, select the New Message button on the right',
                        styleAs: 'list',
                    },
                    {
                        description: 'This will bring up the new message modal',
                        styleAs: 'list'
                    },
                    ...NewMessageModalDetails
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Searching for a message
            {
                heading: 'Searching for a message',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'search', 'message', 'dashboard', 'messages', 'view', 'search', 'filter', 'date', 'time', 'platform', 'email', 'sms', 'whatsapp'],
                sections: [
                    {
                        description: 'To search for a message, navigate to your messages section',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Viewing your messages'
                            }
                        }
                    },
                    {
                        description: 'On the messages search panel on the top of the screen, enter in a search term you would like to search for',
                        styleAs: 'list',
                    },
                    {
                        description: 'To do a quick search, select <b>Quick search from the search options</b>. This will only look for the search term in your message subject or in the recipients list',
                        styleAs: 'list',
                    },
                    {
                        description: 'To do a search in the recipients,subject and message content, select <b>Extended search from the search options</b>.',
                        styleAs: 'list',
                    },
                    {
                        description: 'The system will search through your messages and view the results on the messages panel',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //How to view messages from a specific date range
            {
                heading: 'How to view messages from a specific date range',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'message', 'dashboard', 'messages', 'view', 'search', 'filter', 'date', 'time', 'platform', 'email', 'sms', 'whatsapp'],
                sections: [
                    {
                        description: 'Navigate to your messages section',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Viewing your messages'
                            }
                        }
                    },
                    {
                        description: 'On the messages search panel on the top of the screen, select the date <b>Date From</b> and <b>Date To</b> you would like to filter',
                        styleAs: 'list',
                    },
                    {
                        description: 'The system will search through your messages for messages within that date range and view the results on the messages panel',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //How to view messages from a specific messaging platform
            {
                heading: 'How to view messages from a specific messaging platform',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'message', 'dashboard', 'messages', 'view', 'search', 'filter', 'message type', 'platform', 'email', 'sms', 'whatsapp'],
                sections: [
                    {
                        description: 'Navigate to your messages section',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Messages',
                                sectionName: 'Viewing your messages'
                            }
                        }
                    },
                    {
                        description: 'On the messages search panel on the top of the screen, select the message type you would like to filter',
                        styleAs: 'list',
                    },
                    {
                        description: 'The system will search through your messages for messages on that platform and view the results on the messages panel',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my messages',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Messages',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Setting up a connection to a 3rd party provider messaging platform
            {
                heading: 'Setting up a connection to a 3rd party provider messaging platform',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'integrate', 'set', 'up', 'messages', 'platform', 'email', 'sms', 'whatsapp', 'config'],
                sections: [
                    {
                        description: 'Navigate to the facilities settings by clicking the settings icon on the top right of the dashboard',
                        styleAs: 'list'
                    },
                    {
                        description: 'Select the <b>Setup message service provider</b> option',
                        styleAs: 'list',
                    },
                    {
                        description: 'If the service provider isn\'t currently listed, add them under the <b>New Provider</b> card',
                        styleAs: 'note',
                    },
                    {
                        description: 'Select <b>Add a service</b>',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select messaging service type',
                        styleAs: 'list',
                    },
                    {
                        description: 'Enter a name for the service, eg: facilities SMS service',
                        styleAs: 'list',
                    },
                    {
                        description: 'Enter a name for the service, eg: facilities SMS service',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select configure service',
                        styleAs: 'list',
                    },
                    {
                        description: 'Here you will be able to setup the sending, receiving and user access levels for this service',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the message service setup screen',
                        action: {
                            type: 'location',
                            value: '/Facility/Configuration/Messaging',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}